/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo Planes.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/planes',
    name: 'planes.index',
    component: () => import('./views/PlanesIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'planes.read',
      title: 'Planes',
    },
  },
]

export default routes
